export const pluginGerman = {
  states: {
    Pending: 'Verbindung ausstehend',
    Active: 'Verbunden',
    Disabled: 'Deaktiviert',
    Revoked: 'Zugriff entzogen',
    Empty: 'Noch nicht eingerichtet',
  },
  actions: {
    guest: {
      'checkin-link': { send: 'Check-in-Link senden' },
      'access-instructions': { send: 'Zugangshinweise senden' },
    },
    replies: {
      propose: 'Antworten vorschlagen',
      send: { delegated: 'Geprüfte Antworten senden', automatic: 'Automatische Antworten senden' },
    },
    conversations: { read: 'Gespräche lesen' },
    knowledge: {
      read: 'Wissen lesen',
      manage: 'Wissen pflegen',
      publish: 'Wissen beim Speichern veröffentlichen',
    },
    communication: { settings: { manage: 'Kommunikationseinstellungen verwalten' } },
  },
  capabilities: {
    guest: {
      'checkin-link': { send: 'Check-in-Link senden' },
      'access-instructions': { send: 'Zugangshinweise senden' },
    },
    replies: {
      propose: 'Antworten vorschlagen',
      send: { delegated: 'Geprüfte Antworten senden', automatic: 'Automatische Antworten senden' },
    },
    properties: { knowledge: { read: 'Freigegebene Apartmentinformationen' } },
    conversations: { read: 'Gespräche und Nachrichten' },
    bookings: { context: { read: 'Erforderlicher Buchungskontext' } },
  },
};
export const pluginEnglish = {
  states: {
    Pending: 'Connection pending',
    Active: 'Connected',
    Disabled: 'Disabled',
    Revoked: 'Access revoked',
    Empty: 'Not configured yet',
  },
  actions: {
    guest: {
      'checkin-link': { send: 'Send check-in link' },
      'access-instructions': { send: 'Send access instructions' },
    },
    replies: {
      propose: 'Propose replies',
      send: { delegated: 'Send reviewed replies', automatic: 'Send automatic replies' },
    },
    conversations: { read: 'Read conversations' },
    knowledge: {
      read: 'Read knowledge',
      manage: 'Maintain knowledge',
      publish: 'Publish knowledge on save',
    },
    communication: { settings: { manage: 'Manage communication settings' } },
  },
  capabilities: {
    guest: {
      'checkin-link': { send: 'Send check-in link' },
      'access-instructions': { send: 'Send access instructions' },
    },
    replies: {
      propose: 'Propose replies',
      send: { delegated: 'Send reviewed replies', automatic: 'Send automatic replies' },
    },
    properties: { knowledge: { read: 'Shared apartment information' } },
    conversations: { read: 'Conversations and messages' },
    bookings: { context: { read: 'Required booking context' } },
  },
};
